<app-entidade-envolvida-form
  [entidadeEnvolvida]="entidadeEnvolvida"
  [idEntidade]="idEntidade"
  [entidade]="entidade"
  [tipoEntidadesEnvolvidasSelecionada]="tipoEntidadesEnvolvidasSelecionada"
  (tipoEntidadesEnvolvidasSelecionadaChange)="dadosEntidadeEnvolvida($event)"
  [variasEntidades]="true">
</app-entidade-envolvida-form>

<div class="row mt-4">
  <div class="col-12 d-flex justify-content-end">
    <button nz-button nzType="primary" (click)="handleOk()">{{ this.acao == routeAction.Inserir ? 'Adicionar' : 'Editar' }}</button>
    <button nz-button nzType="default" class="ms-2" (click)="handleCancel()">Cancelar</button>
  </div>
</div>
